/** ডেটা এক্সপোর্ট ও অ্যাকাউন্ট বন্ধ (docs/specs/account-closure.md, SA-20)। */
export const account = {
    title: "ডেটা ও অ্যাকাউন্ট",
    description: "এই ব্যবসার সংরক্ষিত সবকিছু ডাউনলোড করুন, অথবা অ্যাকাউন্ট বন্ধ করুন।",
    export: {
        title: "সব ডেটা এক্সপোর্ট",
        body: "একটি ZIP ফাইল — প্রতিটি টেবিলের জন্য একটি স্প্রেডশিট (CSV): পণ্য, স্টক, বিক্রি, গ্রাহক, হিসাব ইত্যাদি, সাথে আপলোড করা ফাইল। Excel-এ খোলে এবং বাংলা লেখা ঠিক থাকে। পাসওয়ার্ড ও API ক্রেডেনশিয়াল কখনো থাকে না।",
        start: "এক্সপোর্ট তৈরি করুন",
        started: "এক্সপোর্ট তৈরি হচ্ছে। কয়েক মিনিট লাগতে পারে।",
        history: "এক্সপোর্টসমূহ",
        empty: "এখনো কোনো এক্সপোর্ট নেই।",
        status: {
            queued: "অপেক্ষমাণ",
            running: "তৈরি হচ্ছে",
            done: "প্রস্তুত",
            failed: "ব্যর্থ",
            expired: "মেয়াদ শেষ",
        },
        summary: "{{tables}}টি টেবিল · {{rows}}টি সারি · {{files}}টি ফাইল · {{size}}",
        skipped_one: "{{count}}টি ফাইল খুব বড় হওয়ায় রাখা যায়নি (manifest.json-এ তালিকা আছে)।",
        skipped_other: "{{count}}টি ফাইল খুব বড় হওয়ায় রাখা যায়নি (manifest.json-এ তালিকা আছে)।",
        download: "ডাউনলোড",
        keptUntil: "{{date}} পর্যন্ত পাওয়া যাবে",
        requested: "অনুরোধ {{date}}",
        sizeKb: "{{size}} কেবি",
        sizeMb: "{{size}} এমবি",
    },
    closure: {
        title: "অ্যাকাউন্ট বন্ধ করুন",
        body: "বন্ধ করার পর মত বদলানোর জন্য {{days}} দিন সময় পাবেন। এই সময়ে POS সহ সবকিছু চালু থাকবে। এরপর এই ব্যবসার সব রেকর্ড, ফাইল ও ব্যবহারকারী স্থায়ীভাবে মুছে যাবে, আর ফেরত আনা যাবে না।",
        advice: "পরে দরকার হতে পারে মনে হলে আগে ডেটা এক্সপোর্ট করে নিন।",
        start: "অ্যাকাউন্ট বন্ধ করুন…",
        dialogTitle: "এই ব্যবসার অ্যাকাউন্ট বন্ধ করবেন?",
        dialogBody: "{{date}} তারিখে সবকিছু স্থায়ীভাবে মুছে যাবে। তার আগ পর্যন্ত বাতিল করতে পারবেন।",
        reason: "কেন বন্ধ করছেন? (আবশ্যক)",
        confirm: "নিশ্চিত করতে ব্যবসার ওয়েব ঠিকানা লিখুন: {{slug}}",
        submit: "অ্যাকাউন্ট বন্ধ করুন",
        cancel: "অ্যাকাউন্ট রাখুন",
        closing: "এই ব্যবসা {{date}} তারিখে বন্ধ হবে এবং এর ডেটা স্থায়ীভাবে মুছে যাবে।",
        closingOwner: "তার আগ পর্যন্ত বাতিল করতে পারবেন।",
        cancelClosure: "বন্ধ করা বাতিল করুন",
        cancelled: "অ্যাকাউন্ট চালু থাকবে।",
        requestedOk: "অ্যাকাউন্ট {{date}} তারিখে বন্ধ হবে।",
        view: "বিস্তারিত",
    },
};
//# sourceMappingURL=account.js.map